import {
  SAVE_TOKEN_OBJECT_TO_REDUX
} from './dv2Actions';

const initialState = { user: null };

function userObjectRoot (state = initialState, action) {
  switch (action.type) {
    case SAVE_TOKEN_OBJECT_TO_REDUX:
      return { ...state, user: action.payload };

    default:
      return state;
  }
}

export default userObjectRoot;
